import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class UpdateMemberService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private httpClient: HttpClient,
    private common: DatabaseCacheService
  ) { }

  updateMember(memberId: string, putBody) {
    let sectionId = this.common.getSelectedSection().sectionId;
    // this.storeAuth.getSection().subscribe((v) => {
    //   if (!v) {
    //     this.sectionId = localStorage.getItem('gokuri.sectionId');
    //   } else {
    //     this.sectionId = v;
    //   }
    // });

    return this.httpClient.put(`${apiConfig.uri}/licence/${sectionId}/members/${memberId}`, putBody, this.httpOptions);
  }

}
